import { render, staticRenderFns } from "./HoursRendered.vue?vue&type=template&id=670b3c3f"
import script from "./HoursRendered.vue?vue&type=script&lang=js"
export * from "./HoursRendered.vue?vue&type=script&lang=js"
import style0 from "./HoursRendered.vue?vue&type=style&index=0&id=670b3c3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports